var toggleTheme = {
  sizes: {
    xSmall: {
      width: '24px',
      height: '16px',
      borderRadius: '10px',
      padding: '1px'
    },
    small: {
      width: '40px',
      height: '24px',
      borderRadius: '100px',
      padding: '3px'
    },
    regular: {
      width: '48px',
      height: '32px',
      borderRadius: '100px',
      padding: '4px'
    },
    large: {
      width: '72px',
      height: '48px',
      borderRadius: '100px',
      padding: '6px'
    }
  },
  circleSizes: {
    xSmall: {
      width: '12px',
      height: '12px'
    },
    small: {
      width: '16px',
      height: '16px'
    },
    regular: {
      width: '24px',
      height: '24px'
    },
    large: {
      width: '36px',
      height: '36px'
    }
  }
};
export default toggleTheme;